/** @format */

export enum EntryType {
    INLINE = 'inline',
    BLOCK = 'block',
    HYPERLINK = 'hyperlink',
}
export enum SiteSection {
    HOMEPAGE = 'HOMEPAGE',
    SELL_FORM = 'SELL_FORM',
    BRAND_PAGE = 'BRAND_PAGE',
    CATEGORY_PAGE = 'CATEGORY_PAGE',
    MODEL_PAGE = 'MODEL_PAGE',
    JOIN_CONFIRMATION = 'JOIN_CONFIRMATION',
    CONDITIONS_BUY = 'CONDITIONS_BUY',
    MY_ACCOUNT_PAGE = 'MY_ACCOUNT_PAGE',
    OTHER = 'OTHER',
    BRANDS = 'BRANDS',
    CONTACT_US_PAGE = 'CONTACT_US_PAGE',
    ORIGINAL_CONTENT_HUB = 'ORIGINAL_CONTENT_HUB',
    LEARN_CHECKING_PROCESS = 'LEARN_CHECKING_PROCESS',
    QUOTE_SUMMARY = 'QUOTE_SUMMARY',
    CONDITIONS_SELL = 'CONDITIONS_SELL',
    ADJUSTED_QUOTE = 'ADJUSTED_QUOTE',
    ORDER_CONFIRMATION = 'ORDER_CONFIRMATION',
    LISTING_PAGE_REDUCED = 'LISTING_PAGE_REDUCED',
    LISTING_PAGE_SPARES_AND_REPAIRS = 'LISTING_PAGE_SPARES_AND_REPAIRS',
    LISTING_PAGE_NEWLY_LISTED = 'LISTING_PAGE_NEWLY_LISTED',
} /** @format */

export enum ContentCollectionVariant {
    THREE_COL_CIRCULAR_IMAGES = '3_COL_CIRCULAR_IMAGES',
    TWO_COL_IMAGES_LEFT = '2_COL_IMAGES_LEFT',
    TWO_COL_CARDS = '2_COL_CARDS',
}

export enum SectionPreviewBlockImagePosition {
    LEFT = 'left',
    RIGHT = 'right',
}

export enum SectionPreviewBlockVariant {
    SUSTAINABILITY = 'SUSTAINABILITY',
    FLAME = 'FLAME',
}

export enum ContentfulEntryType {
    BASIC_PAGE = 'PageHelp',
    CATEGORY = 'ContentCategory',
    ARTICLE = 'Article',
    LANDING_PAGE = 'LandingPage',
}

export enum TypenameTemplatePath {
    PageHelp = '/cms/basic',
    LandingPage = '/cms/landing-page',
    Category = '/content/category',
    Article = '/content/article',
    Contact = '/help/contact',
}
